/**
 * @voltxampere/ui — Brushless DC (BLDC) motor variant (Sprint 44-7, placeholder)
 *
 * PLACEHOLDER. Fırçasız DC motor — 3-phase Y veya Δ winding +
 * elektronik komütasyon (ESC). Mevcut `voltage-source` stamp
 * üzerinden 12V drive placeholder; gerçek 3-phase sinusoidal /
 * trapezoidal komütasyon + Hall sensor / sensorless BEMF feedback
 * Sprint 47+ engine extension #4 ile (3-phase composition + ESC
 * controller stamp).
 *
 * Reference: Generic outrunner BLDC — T-Motor MN3508, EMAX RS2205.
 * V = 12-24 V, kV = 600-2300 RPM/V. Drone + electric vehicle
 * propulsion + CNC spindle + e-bike hub motor.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const motorBldc = {
    id: "motor-bldc",
    nameTr: "BLDC Motor 12V (3-phase, placeholder)",
    nameEn: "BLDC Motor 12V (3-phase, placeholder)",
    shortcut: "V",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "M",
    defaultValue: "BLDC-12V",
    schemaType: "voltage-source",
    defaultParams: { voltage: 12 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=motor-bldc.js.map